import styled from '@emotion/styled';
import { Text } from 'components';
import { Link } from 'react-router-dom';
import { t } from '@lingui/macro';
import { BaseButton } from 'components/button';
import { useTheme } from '@emotion/react';

type AuthLinkProps = {
  linkTo?: string;
  questionText?: string;
  linkText?: string;
  newTab?: boolean;
  onClick?: () => void;
  light?: boolean;
};

export const AuthLink = ({
  linkTo,
  questionText = t`Not already a user?`,
  linkText = t`Sign up here`,
  newTab = false,
  onClick,
  light = false,
}: AuthLinkProps) => {
  const theme = useTheme();
  const color = light ? theme.palette.text.tertiary : theme.palette.text.secondary;
  return (
    <AuthLinkContainer>
      <Text variant="bodyXs" color={color}>
        {questionText}
      </Text>
      {linkTo ? (
        <Link to={linkTo} target={newTab ? '_blank' : undefined} onClick={onClick}>
          <Text variant="bodyXs" weight="semiBold" underlined color={color}>
            {linkText}
          </Text>
        </Link>
      ) : null}
      {onClick && !linkTo ? (
        <BaseButton onClick={onClick} type="button">
          <Text variant="bodyXs" weight="semiBold" underlined color={color}>
            {linkText}
          </Text>
        </BaseButton>
      ) : null}
    </AuthLinkContainer>
  );
};

const AuthLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
`;
